import React, { useContext, useEffect, useState } from 'react';
import en from '../languages/en.json';
import th from '../languages/th.json';

const LanguageContext = React.createContext();
const LanguageUpdateContext = React.createContext();
const DictContext = React.createContext();
const UrlContext = React.createContext();
const PreInvestmentScreeningModalContext = React.createContext();

export function useLanguage() {
    return useContext(LanguageContext);
}

export function useLanguageUpdate() {
    return useContext(LanguageUpdateContext);
}

export function useDict() {
    return useContext(DictContext);
}

export function useUrl() {
    return useContext(UrlContext);
}

export function usePreInvestmentScreeningModal() {
    return useContext(PreInvestmentScreeningModalContext);
}

export function LanguageProvider({ children }) {
    const [dict, setDict] = useState({});
    const [url, setUrl] = useState();
    const [isShowPreInvestmentScreeningModal, setIsShowPreInvestmentScreeningModal] = useState(false);
    const language = localStorage.getItem('language');

    useEffect(() => {
        localStorage.setItem('language', language === 'en' ? 'en' : 'th');
        setDict(language === 'th' ? th : en);
    }, [url, isShowPreInvestmentScreeningModal]);

    function toggleLanguage(newLanguage) {
        localStorage.setItem('language', newLanguage === 'en' ? 'en' : 'th');
        window.location.reload();
    };

    function updateUrl(url) {
        setUrl(url);
    };

    function togglePreInvestmentScreeningModal() {
        setIsShowPreInvestmentScreeningModal(!isShowPreInvestmentScreeningModal);
    };

    return (
        <LanguageContext.Provider value={language}>
            <LanguageUpdateContext.Provider value={toggleLanguage}>
                <DictContext.Provider value={dict}>
                    <UrlContext.Provider value={{ url, updateUrl }}>
                        <PreInvestmentScreeningModalContext.Provider value={{ isShowPreInvestmentScreeningModal, togglePreInvestmentScreeningModal }}>
                            {children}
                        </PreInvestmentScreeningModalContext.Provider>
                    </UrlContext.Provider>
                </DictContext.Provider>
            </LanguageUpdateContext.Provider>
        </LanguageContext.Provider>
    );
}
